import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { StripeCoupon } from '@/modules/billing/models/stripe/StripeCoupon';

export class StripeDiscount extends BaseModel {
  public coupon: Relationship<StripeCoupon>;
  public invoiceItem: string | null;

  constructor(model: Partial<StripeDiscount> = {}) {
    super(model);

    this.coupon = StripeCoupon.mapModel(model.coupon);
    this.invoiceItem = model.invoiceItem || null;
  }
}
